export default "__VITE_ASSET__Um2SmFka__"